<template>
  <div class="Users">
    <v-speed-dial
      v-model="dials"
      fixed
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
    > 
      <template v-slot:activator>
        <v-btn
          v-model="dials"
          color="pink"
          dark
          fab
        >
          <v-icon v-if="dials">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>
        
      <v-btn 
        v-if="selection.length > 0"
        small
        color="red darken-1"
        dark
        fab
        @click="log('delete')"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>

      <v-btn 
          v-if="selection.length === 1"
          fab
          small
          color="deep-purple darken-4"
          dark
          @click="edit"
      >
          <v-icon>mdi-square-edit-outline</v-icon>
      </v-btn>

      <v-btn
        v-if="selection.length === 0"
        small
        color="success"
        fab
        left
        @click="log('add')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-tabs 
      vertical
      color="deep-purple darken-4"
      @change="tabChange"
      v-model="tabs"
    >
      <v-tab class="justify-start" v-if="$store.getters['auth/isAdmin']">
        <v-icon left>mdi-account-card-details</v-icon>
        Utilisateurs
      </v-tab>
      
      <v-tab class="justify-start" v-if="$store.getters['auth/isAdmin']">
        <v-icon left>mdi-account-group</v-icon>
        Rôles
      </v-tab>        

      <v-tab-item v-if="$store.getters['auth/isAdmin']">
        <v-card flat>
          <v-card-text>
            <v-data-table v-if="Boolean(users.length)"
              :items="users"
              item-key="email"
              :headers="headers"
              v-model="selection"
              show-select
            >
              <template v-slot:item.customClaims="{ item }">
                  <span>{{ Boolean(item.customClaims) ? Object.keys(item.customClaims).join(', ') : '---' }}</span>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-text>
            <v-expand-transition>
              <v-text-field
                v-if="action === 'adding'"
                type="email"
                label="Assigner le rôle d'administrateur à un utilisateur existant"
                placeholder="Courriel"
                v-model="selected"
              ></v-text-field>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item v-if="$store.getters['auth/isAdmin']">
        <v-card flat>
          <v-card-text>
            <span class="subheading">Roles</span>
            <v-expand-transition>
              <v-chip-group
                v-if="!Boolean(addTag)"
                column
                multiple
                v-model="roleTags"
                active-class="deep-purple darken-4 white--text"
              >
                <v-chip
                  v-for="tag in roleTags" 
                  :key="`option-${tag.value}`"
                  :value="tag.value"
                >
                  {{ tag.text }}
                </v-chip>

                <v-btn
                  fab
                  x-small
                  class="deep-purple darken-4 ml-5 my-1"
                  dark
                  text
                  @click="addTag = true"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-chip-group>
            </v-expand-transition>

            <v-expand-transition>
              <div v-if="Boolean(addTag)" class="d-flex align-center">
                <v-text-field
                  v-model="tag.text"
                  prepend-icon="mdi-tag-text"
                  label="Nom de la catégorie"
                />
                <v-spacer></v-spacer>

                <v-text-field
                  v-model="tag.value"
                  prepend-icon="mdi-pound"
                  :messages="[`Valeur du tag`]"
                />
                <v-spacer></v-spacer>

                <v-btn
                  fab
                  x-small
                  class="red ml-2"
                  dark
                  @click="createTag"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-btn
                  fab
                  x-small
                  class="success ml-2"
                  dark
                  @click="createTag"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </div>
            </v-expand-transition> 
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>    

    <!-- <v-dialog 
      v-model="dialog"
      scrollable 
      @click:outside="clearDialog"
    >        
      <RolesDialog 
        ref="rolesDialogCard"
        :item="role"
        :roles="roles"
        @clearDialog="clearDialog" 
        @saveList="saveList" 
      />
    </v-dialog> -->
  </div>
</template>

<script>
import RolesDialog from '@/components/RolesDialog.vue'
import firebase from "firebase/app"
import 'firebase/functions'

export default {
  name: 'Users',
  components: {
    RolesDialog,
  },
  data() {
    return {
      tabs: 0,
      dials: false,
      selection: [],
      users: [],
      admins: [],
      addTag: false,
      tag: {
        value: null,
        text: null,
      },
      role: {
        id: null,
        name: null,
      },
      action: null,
      dialog: false,
      controls: [
        {
          name: `cancel`,
          text: `Annuler`,
          icon: `mdi-close`,
          color: `red`,
          condition: () => {
            return this.action !== null
          },
          action: () => {
            this.action = null
          },
        },
        {
          name: `list`,
          text: `Liste`,
          icon: `mdi-format-list-bulleted`,
          color: `blue darken-4`,
          condition: () => {
            return this.action === null
          },
          action: () => {
            this.listAllUsers()
          },
        },
        {
          name: `add`,
          text: `Ajouter`,
          icon: `mdi-plus`,
          color: `pink`,
          condition: () => {
            return this.action === null
          },
          action: () => {
            this.action = 'adding'
          },
        },
        {
          name: `confirm`,
          text: `Confirmer`,
          icon: `mdi-check`,
          color: `deep-purple darken-4`,
          condition: () => {
            return this.action !== null
          },
          action: () => {
            this.addNewAdminUser()
          }
        }
      ],
    }
  },
  computed: {
    headers() { return this.$store.state.auth.headers },
    roles() { return this.$store.state.app.roles },
    roleTags() {
      console.log(this.roles)
      return []
    }
  },
  methods: {
    log(msg) {
      console.log(msg)
    },
    delete() {},
    createTag() {
      console.log(this.tag)
      this.initTag()
    },
    tabChange(e) {
      //console.log(`Active tab changed to ${this.tabs}. Use 'this.tabs' (returns int) to take advantage of active tab...`)
    },
    saveRole() {
      
    },
    listAllUsers() {
      const listUsers = firebase.functions().httpsCallable('listAllUsers')
      listUsers().then(res => { this.users = res.data.users })
    },
    addNewAdminUser() {
      const addAdminRole = firebase.functions().httpsCallable('addAdminRole')

      addAdminRole({ email: this.selected })
      .then(res => {
        console.log(res)
      })
    },
    clearDialog() {
      this.hideDialog()
      this.reset()
    },
    hideDialog() {
      this.dialog = {
        show: false,
        item: null,
        form: null,
      }
    },
    initTag() {
      this.tag = {
        value: null,
        text: null,
      }
      this.addTag = false
    },
    reset() {
      this.initTag()
    },
  },
  created() {
    this.listAllUsers()
  },
}
</script>
